import {useNavigate} from 'react-router-dom'
import styles from './ChamadoCard.module.css'
import SituacaoBadge from './SituacaoBadge'

function ChamadoCard({id, usuarioAutor, usuarioInteracao, dataUltimaInteracao, grupoEmpresa, empresa, dataCriacao, dataFechamento, motivos, prioridadeExterna, prioridadeInterna, responsaveis, usuarioFechamento, SLAInterna, SLAExterna, nomeModulo, situacao, nowTick}) {
    const navigate = useNavigate()
    const responsaveisLabel = responsaveis.length > 0
        ? (responsaveis.map((usr) => { return usr.CD_USUARIO; })).join(', ')
        : 'SEM RESPONSÁVEIS'
    const responsaveisNomes = responsaveis.map((usr) => { return usr.CD_USUARIO; })
    const tagsNomes = motivos.map((motivo) => { return motivo.TX_MOTIVO; })
    const tagsPrimeira = tagsNomes[0] || 'SEM TAGS'
    const tagsOcultas = tagsNomes.slice(1)
    const tagsLabel = tagsOcultas.length > 0 ? `${tagsPrimeira} (${tagsOcultas.length})` : tagsPrimeira
    const dataAbertura = dataCriacao ? dataCriacao.split(' ')[0] : ''
    const responsavelPrincipal = responsaveisNomes[0] || 'SEM RESPONSÁVEL'
    const prioridadeClasse = prioridadeInterna ? `priority-${prioridadeInterna}` : 'priority-none'
    const titulo = nomeModulo ? nomeModulo.substr(0, 115) : 'SEM TÍTULO'
    const parseDateTime = (value) => {
        if (!value || typeof value !== 'string') return null
        if (value.includes('/')) {
            const [datePart, timePart] = value.split(' ')
            const [day, month, year] = datePart.split('/').map(Number)
            const [hour = 0, minute = 0, second = 0] = (timePart || '').split(':').map(Number)
            const parsed = new Date(year, (month || 1) - 1, day || 1, hour || 0, minute || 0, second || 0)
            return Number.isNaN(parsed.getTime()) ? null : parsed
        }
        const normalized = value.includes('T') ? value : value.replace(' ', 'T')
        const parsed = new Date(normalized)
        return Number.isNaN(parsed.getTime()) ? null : parsed
    }

    const openedAt = parseDateTime(dataCriacao)
    const now = nowTick || Date.now()
    const isSameDay = (a, b) => (
        a.getFullYear() === b.getFullYear()
        && a.getMonth() === b.getMonth()
        && a.getDate() === b.getDate()
    )
    const isNew = openedAt ? isSameDay(openedAt, new Date(now)) : false

    const getInitials = (nome) => {
        if (!nome) return '??'
        const trimmed = nome.trim()
        if (!trimmed) return '??'
        const parts = trimmed.split(/\s+/)
        if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase()
        return `${parts[0][0]}${parts[1][0]}`.toUpperCase()
    }

    return (
        <div
            className={`${styles.ticketCard} ${styles[prioridadeClasse]}`}
            role="link"
            tabIndex={0}
            onClick={() => navigate(`/chamado/${id}`)}
            onKeyDown={(event) => {
                if (event.key === 'Enter' || event.key === ' ') {
                    event.preventDefault()
                    navigate(`/chamado/${id}`)
                }
            }}
        >
            {isNew && <span className={styles.newAlert} aria-label="Novo chamado">!</span>}
            <div className={styles.ticketHeader}>
                <div className={styles.ticketInfo}>
                    <div className={styles.ticketId}>#{id} • Aberto em {dataAbertura}</div>
                    <div className={styles.ticketTitle}>{titulo}</div>
                    <div className={styles.ticketMeta}>
                        <div className={styles.metaItem}>
                            <span>{empresa || grupoEmpresa}</span>
                        </div>
                        <div className={styles.metaItem}>
                            <span>Última atividade: {dataUltimaInteracao}</span>
                        </div>
                        <div className={styles.metaItem}>
                            <span className={`${styles.badge} ${styles.badgeTag}`}>{tagsLabel}</span>
                        </div>
                        {situacao && (
                            <div className={styles.metaItem}>
                                <SituacaoBadge situacao={situacao} />
                            </div>
                        )}
                        {isNew && (
                            <div className={styles.metaItem}>
                                <span className={`${styles.badge} ${styles.badgeNew}`}>NOVO</span>
                            </div>
                        )}
                    </div>
                </div>
                <span className={`${styles.badge} ${responsaveisNomes.length > 0 ? styles.badgeAssigned : styles.badgePending}`}>
                    {responsaveisLabel}
                </span>
            </div>

            <div className={styles.ticketFooter}>
                <div className={styles.assignee}>
                    <div className={styles.avatar}>{getInitials(responsavelPrincipal)}</div>
                    <span>{responsavelPrincipal}</span>
                </div>
            </div>
        </div>
        )
}

export default ChamadoCard
